export const ONE_MAN_STANDARD_DELIVERY = "1";
export const ONE_MAN_STANDARD_DELIVERY_64 = "64";
export const SUPPLIER_DIRECT = "14";
export const SUPPLIER_DIRECT_3_DAY = "410";
export const SUPPLIER_DIRECT_4_DAY = "411";
export const LOCAL_COLLECTION = "413";
export const TRADEPLACE = "418";
export const ONE_MAN_SPECIALIST_DELIVERY = "25";
export const HP_DELIVERY = "155";
export const CLICK_AND_COLLECT = "187";
export const TWO_MAN_STANDARD_DELIVERY = "26";
